import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const OrderingIconButton = (props) => {
  const { fieldKey, ordering, setOrdering, visible } = props;
  const isAsc = ordering === fieldKey;
  const isDesc = ordering === `-${fieldKey}`;

  // Take space when hidden so the table header doesn't shift on hover.
  if (!visible && !isAsc && !isDesc) {
    return (
      <IconButton disabled aria-hidden>
        <ArrowUpwardIcon fontSize="small" style={{ visibility: 'hidden' }} />
      </IconButton>
    );
  }

  if (!isAsc && !isDesc) {
    return (
      <Tooltip title="Sort ascending">
        <IconButton
          onClick={() => setOrdering(fieldKey)}
          aria-label={`Sort by ${fieldKey} ascending`}
        >
          <ArrowUpwardIcon fontSize="small" color="disabled" />
        </IconButton>
      </Tooltip>
    );
  }

  if (isAsc) {
    return (
      <Tooltip title="Sort descending">
        <IconButton
          onClick={() => setOrdering(`-${fieldKey}`)}
          aria-label={`Sort by ${fieldKey} descending`}
        >
          <ArrowUpwardIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  // isDesc
  return (
    <Tooltip title="Clear sort">
      <IconButton
        onClick={() => setOrdering(null)}
        aria-label={`Clear sort on ${fieldKey}`}
      >
        <ArrowDownwardIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

OrderingIconButton.propTypes = {
  fieldKey: PropTypes.string.isRequired,
  ordering: PropTypes.string.isRequired,
  setOrdering: PropTypes.func.isRequired,
  visible: PropTypes.bool,
};

export default OrderingIconButton;
